module.exports = __webpack_public_path__ + "html/open-editor_cc8d6ab412bdf1def49150e25d65da97.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/open-editor.html
// module id = tp6s
// module chunks = 154